export function getStyle(id) {
    return `#${id} {
  max-width: 800px;
  margin: 0 auto;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

#${id} .settings {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  align-items: end;
  gap: 15px 20px;
  margin-bottom: 10px;
  padding-bottom: 15px;
}

#${id} .setting-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

#${id} .setting-holder {
  grid-column: span 2;
}

#${id} .setting-solvent {
  grid-column: span 4;
}

#${id} .setting-item-inline {
  grid-column: span 3;
  flex-direction: row;
  align-items: center;
}

#${id} .setting-item > label {
  font-weight: bold;
  color: #333;
  font-size: 14px;
}

#${id} .setting-item-inline label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  user-select: none;
}

#${id} .holder-input,
#${id} .solvent-select {
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

#${id} .holder-input:focus,
#${id} .solvent-select:focus {
  outline: none;
  border-color: #007bff;
}

#${id} .delete-existing-holder-toggle,
#${id} .auto-import-toggle {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

#${id} .tabs {
  display: flex;
  gap: 5px;
  border-bottom: 2px solid #ddd;
  margin-bottom: 20px;
}

#${id} .tab {
  padding: 10px 20px;
  background-color: #f0f0f0;
  border: none;
  border-radius: 5px 5px 0 0;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

#${id} .tab:hover {
  background-color: #e0e0e0;
}

#${id} .tab.active {
  background-color: #007bff;
  color: white;
}

#${id} .tab-content {
  display: none;
}

#${id} .tab-content.active {
  display: block;
}

#${id} .experiment-item {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 10px;
  background-color: #fafafa;
}

#${id} .experiment-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

#${id} .experiment-toggle {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

#${id} .experiment-header label {
  font-weight: bold;
  color: #333;
  user-select: none;
}

#${id} .experiment-parameters {
  margin-top: 15px;
  padding-left: 28px;
}

#${id} .parameter-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

#${id} .parameter-item label {
  min-width: 150px;
  color: #555;
  font-size: 14px;
}

#${id} .parameter-input {
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

#${id} .parameter-input:focus {
  outline: none;
  border-color: #007bff;
}
`;
}
//# sourceMappingURL=getStyle.js.map